import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { GalleryState } from '../../state/gallery.state';
import { Observable } from 'rxjs';
import { GalleryViewMode } from '../../models/gallery-view-mode.enum';
import { GalleryActions } from '../../state/gallery.actions';

@Component({
  selector: 'app-gallery-view-mode',
  templateUrl: './gallery-view-mode.component.html',
  styleUrls: ['./gallery-view-mode.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GalleryViewModeComponent implements OnInit {
  galleryViewMode = GalleryViewMode;

  @Select(GalleryState.getViewMode)
  viewMode$: Observable<GalleryViewMode>;

  constructor(
    private store: Store
  ) { }

  ngOnInit() {
  }

  handleViewModeClick(viewMode: GalleryViewMode) {
    this.store.dispatch(new GalleryActions.SetViewMode(viewMode));
  }

}
